import { useContext } from "react";
import { ArrayField, BooleanField, BooleanInput, Datagrid, Edit, FormTab, PasswordInput, SaveButton, TabbedForm, TextField, TextInput, Toolbar } from "react-admin";
import MaskedInput from "../../components/masked-input";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const CustomToolbar = props => {
    return <Toolbar {...props} >
        <SaveButton disabled={props.pristine} />
    </Toolbar>
}

const UserEdit = (props) => {

    const context = useContext(AppContext)

    const CustomTitle = ({ record }) => {
        return <span>{record.name}</span>
    }

    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN;
    const emailHelperText = 'Para melhor utilização do sistema de notificações via email, não recomendamos a utilização de endereços de email @outlook, @hotmail e @live.';

    return (
        <Edit
            mutationMode="pessimistic"
            {...props}
            title={<CustomTitle />}
        >
            <TabbedForm toolbar={<CustomToolbar />}>
                <FormTab label={'Dados Gerais'}>
                    <TextInput source="name" label={'Nome'} fullWidth />
                    <TextInput source="email" label={'Email'} type={'email'} helperText={emailHelperText} fullWidth />
                    <MaskedInput source="phone" onlyNumbers={true} mask={'(99) 99999-9999'} label={'Telefone'} fullWidth />
                    <BooleanInput source="active" label={'Ativo?'} fullWidth />
                    {
                        superAdmin &&
                        <>
                            <PasswordInput source="password" label={'Senha'} fullWidth />
                            <PasswordInput source="passwordConfirmation" label={'Confirme a senha'} fullWidth />
                        </>
                    }


                </FormTab>
                {superAdmin && <FormTab label={'Contextos'} path="contexts">
                    <ArrayField fullWidth source="user_contexts" label={'Contextos'}>
                        <Datagrid>
                            <TextField source="institution_branch.institution.name" label={'Institutição'} />
                            <TextField source="institution_branch.name" label={'Unidade'} />
                            <TextField source='profile.name' label={'Perfil'} />
                            <BooleanField source="active" label={'Ativo?'} />
                        </Datagrid>
                    </ArrayField>
                </FormTab>}
            </TabbedForm>
        </Edit>
    )
}

export default UserEdit;